export default __webpack_public_path__ + "static/media/jonathanSchubauer.c7c724e4.png";